/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Button, { BUTTON_COLORS } from "@/components/Button/Button";

import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "@dotnet/telematics-design-system";

interface GridNavigationArrowsProps {
  onBack: () => void;
  onForward: () => void;
  backDisabled?: boolean;
  forwardDisabled?: boolean;
}

const GridNavigationArrows = ({
  onBack,
  onForward,
  backDisabled = false,
  forwardDisabled = false
}: GridNavigationArrowsProps) => {
  const iconStyle = css({
    width: "16px",
    height: "16px"
  });

  return (
    <div
      css={css({
        display: "flex",
        gap: "4px"
      })}
    >
      <Button
        color={BUTTON_COLORS.White}
        variant="iconOnly"
        size="tiny"
        icon={<ChevronLeftIcon css={iconStyle} />}
        onClick={onBack}
        disabled={backDisabled}
      />

      <Button
        color={BUTTON_COLORS.White}
        variant="iconOnly"
        size="tiny"
        icon={<ChevronRightIcon css={iconStyle} />}
        onClick={onForward}
        disabled={forwardDisabled}
      />
    </div>
  );
};

export default GridNavigationArrows;
